import useAsync from 'react-use/esm/useAsync';
import { bitriseApiRef } from '../plugin.esm.js';
import { useApi } from '@backstage/core-plugin-api';

const useBitriseArtifacts = (appSlug, buildSlug) => {
  const bitriseApi = useApi(bitriseApiRef);
  return useAsync(
    () => bitriseApi.getBuildArtifacts(appSlug, buildSlug),
    [bitriseApi, appSlug, buildSlug]
  );
};

export { useBitriseArtifacts };
//# sourceMappingURL=useBitriseArtifacts.esm.js.map
